export default __webpack_public_path__ + "static/media/Page25.ebcd8834.txt";